import GlowingIcon from './GlowingIcon';

export default GlowingIcon;
